/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.inbox.MaximegalonStatus
*/
export var MaximegalonStatus;
(function (MaximegalonStatus) {
    MaximegalonStatus["PENDING"] = "PENDING";
    MaximegalonStatus["ANSWERED"] = "ANSWERED";
    MaximegalonStatus["DISMISSED"] = "DISMISSED";
    MaximegalonStatus["ARCHIVED"] = "ARCHIVED";
})(MaximegalonStatus || (MaximegalonStatus = {}));
//# sourceMappingURL=MaximegalonStatus.js.map